import React from 'react';
import { Grid, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { MetricSummaryPaper, MetricItemBox, MetricCountTypography } from '../components/MuiStyledComponents';

function SCMetrics({ onMetricClick, metrics, isLoading, error }) {
  if (isLoading) {
    return (
        <MetricSummaryPaper>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                <CircularProgress />
                <Typography sx={{ ml: 2 }}>Loading Metrics...</Typography>
            </Box>
        </MetricSummaryPaper>
    );
  }

  if (error) {
    return (
      <MetricSummaryPaper>
          <Alert severity="error">{error}</Alert>
      </MetricSummaryPaper>
    );
  }

  if (!metrics) {
    return (
      <MetricSummaryPaper>
          <Typography>Metrics data is currently unavailable.</Typography>
      </MetricSummaryPaper>
    );
  }

  const clickableBoxStyle = {
      cursor: 'pointer',
      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
      '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: 6,
      },
  };

  return (
    <MetricSummaryPaper>
      <Typography variant="h3" component="h3" sx={{ color: 'primary.dark', mb: 2, textAlign: 'center' }}>
        Enquiry Status Overview
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={3}>
          <MetricItemBox onClick={() => onMetricClick({ status: '' })} sx={clickableBoxStyle}>
            <MetricCountTypography>{metrics.totalEnquiries}</MetricCountTypography>
            <Typography variant="metricLabel">Total Enquiries</Typography>
          </MetricItemBox>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MetricItemBox onClick={() => onMetricClick({ status: 'Pending with SCM' })} sx={clickableBoxStyle}>
            <MetricCountTypography>{metrics.enquiriesPendingScm}</MetricCountTypography>
            <Typography variant="metricLabel">Pending With SCM</Typography>
          </MetricItemBox>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MetricItemBox onClick={() => onMetricClick({ status: 'Pending with BDM' })} sx={clickableBoxStyle}>
            <MetricCountTypography>{metrics.enquiriesPendingBdm}</MetricCountTypography>
            <Typography variant="metricLabel">Pending With BDM</Typography>
          </MetricItemBox>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MetricItemBox onClick={() => onMetricClick({ status: 'Closed Won' })} sx={clickableBoxStyle}>
            <MetricCountTypography>{metrics.enquiriesClosedWon}</MetricCountTypography>
            <Typography variant="metricLabel">Closed Won</Typography>
          </MetricItemBox>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MetricItemBox onClick={() => onMetricClick({ status: 'Closed Lost' })} sx={clickableBoxStyle}>
            <MetricCountTypography>{metrics.enquiriesClosedLost}</MetricCountTypography>
            <Typography variant="metricLabel">Closed Lost</Typography>
          </MetricItemBox>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MetricItemBox onClick={() => onMetricClick({ status: 'On Hold' })} sx={clickableBoxStyle}>
            <MetricCountTypography>{metrics.enquiriesOnHold}</MetricCountTypography>
            <Typography variant="metricLabel">On Hold</Typography>
          </MetricItemBox>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MetricItemBox onClick={() => onMetricClick({ status: 'Pending With Client' })} sx={clickableBoxStyle}>
            <MetricCountTypography>{metrics.enquiriesPendingClient}</MetricCountTypography>
            <Typography variant="metricLabel">Pending With Client</Typography>
          </MetricItemBox>
        </Grid>
      </Grid>
    </MetricSummaryPaper>
  );
}

export default SCMetrics;